package horcrux.frontend.common.views.chat

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.views.components.containers.VStack
import mui.material.Typography
import mui.material.TypographyAlign
import mui.material.styles.TypographyVariant
import mui.system.PropsWithSx
import mui.system.sx
import react.FC
import web.cssom.FontFamily
import web.cssom.pt

data class ChatMessageData(val content: String, val messageSenderData: MessageSenderData) {
    constructor(inputPrompt: InputPrompt, messageSenderData: MessageSenderData) : this(
        inputPrompt.value,
        messageSenderData
    )
}

external interface ChatMessageProps : PropsWithSx {
    var chatMessageData: ChatMessageData
    var globalAppState: GlobalAppState
}

val ChatMessage = FC<ChatMessageProps> { props ->
    VStack {
        this.sx { +props.sx }
        props.chatMessageData.messageSenderData.messageSender(this@VStack, props.globalAppState)
        Typography {
            +props.chatMessageData.content
            this.variant = TypographyVariant.caption
            this.align = TypographyAlign.left
            this.sx {
                this.fontFamily = FontFamily.sansSerif
                this.fontSize = 12.pt
            }
        }
    }
}
